var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "inputForm",
          attrs: {
            size: "small",
            model: _vm.inputForm,
            disabled: _vm.formReadOnly,
            "label-width": "120px",
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 15 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "请假类型",
                        prop: "leaveType",
                        rules: [
                          {
                            required: true,
                            message: "请假类型不能为空",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.inputForm.leaveType,
                            callback: function ($$v) {
                              _vm.$set(_vm.inputForm, "leaveType", $$v)
                            },
                            expression: "inputForm.leaveType",
                          },
                        },
                        _vm._l(
                          _vm.$dictUtils.getDictList("oa_leave_type"),
                          function (item) {
                            return _c(
                              "el-radio",
                              { key: item.value, attrs: { label: item.value } },
                              [_vm._v(_vm._s(item.label))]
                            )
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "请假开始时间",
                        prop: "startTime",
                        rules: [
                          {
                            required: true,
                            message: "请假开始时间不能为空",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          placeholder: "选择日期时间",
                        },
                        model: {
                          value: _vm.inputForm.startTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "startTime", $$v)
                          },
                          expression: "inputForm.startTime",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "请假结束时间",
                        prop: "endTime",
                        rules: [
                          {
                            required: true,
                            message: "请假结束时间不能为空",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          placeholder: "选择日期时间",
                        },
                        model: {
                          value: _vm.inputForm.endTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "endTime", $$v)
                          },
                          expression: "inputForm.endTime",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "请假事由",
                        prop: "reason",
                        rules: [
                          {
                            required: true,
                            message: "请假事由不能为空",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          placeholder: "请填写请假事由",
                        },
                        model: {
                          value: _vm.inputForm.reason,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "reason", $$v)
                          },
                          expression: "inputForm.reason",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }